var ClientProvider = /** @class */ (function () {
    function ClientProvider() {
    }
    ClientProvider.prototype.appendQuery = function (requestQuery) {
        var query = Object.keys(requestQuery)
            .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(requestQuery[k]); })
            .join('&');
        return '?' + query;
    };
    return ClientProvider;
}());
export { ClientProvider };
//# sourceMappingURL=ClientProvider.js.map